import s from "./all_region_site_toggle.module.css";

export default function AllSiteRegionToggle(props) {
  let { onClick, mode = null, enableRegion = false } = props;

  if (enableRegion && !mode) {
    mode = "region";
  } else if (!mode) {
    mode = "site";
  }

  return (
    <div className={s.wrapper}>
      {enableRegion ? (
        <div className={mode === "region" ? s.active_right : s.right} onClick={() => onClick("region")}>
          REGION
        </div>
      ) : null}
      <div className={mode === "site" ? s.active_right : s.right} onClick={() => onClick("site")}>
        SITE
      </div>
    </div>
  );
}
